export enum ESharedFunction {
    "AnxietyLevelSelector_level",
    "BookOfMind",
    "BookOfMindSearch_searchText",
    "BottomBarPervasiveState_value",
    "BreadCrumbs_state",
    "BroadStateSelectors_keyValueUpdateTime",
    "BroadState_material",
    "BroadState_mental",
    "BroadState_physical",
    "BroadState_social",
    "BroadState_spontaneity",
    "BroadState_creativity",
    "BroadState_stability",
    "BroadState_achievement",
    CalendarEventEditor_state,
    "CalendarNumberOfEventsSelector_number",
    ChessBoard,
    "CICO_calories",
    "CICO_protein",
    "CICO_weight",
    "ComfortSelector_level",
    "Default",
    "DisplayStopWatch_startDateTime",
    "Diversity_target",
    DopamineMenu_activeEmotion,
    "DreamsLevelSelector_level",
    "EmotionSelector_character",
    "EnergyLevelSelector_level",
    "FoodSelector_level",
    "FontSwitcher_useAnopenscrollFont",
    "GameDifficultySelector_difficulty",
    "GoalLimitWarnings_data",
    "GutSelector_level",
    "InCenterOfScreen_toRender",
    "KeyValueLogs_state",
    "KeyValueLogs_percentValue",
    "Loading",
    "LogInputParticles_show",
    "MasteryTitle_isOK",
    "MemoryBoxContainer_timestamp",
    "MoveNode",
    "NavigationMenu_activePanel",
    "PervasiveState_value",
    "Phrasing_state",
    "Prayer_state",
    ProblemsActivated_problemCount,
    "RadialSurvivalGuide_dataIndex",
    "RadialSurvivalGuide_isVisible",
    RadialSurvivalGuide_items,
    RenderChildNodes_state,
    RootNodeName_state,
    "RouterNavigationTarget_Target",
    "SelectRandomGoalCardFloatingTool_randomTime",
    "ShowCurrentEnergy_currentValue",
    "Stacks_difficulty",
    "Stacks_state",
    "StackFocus_criticalHashTags",
    "StackFocus_metaProblemPriorities",
    "Stars",
    "StimulationLevelSelector_level",
    "Sunrise_progressPercent",
    "SyncNotification_state",
    "SystemDateWarning_offset",
    "TodayNodesStack_state",
    "ToggleDeviceMode_isDesktopModeAllowed",
    "TypeAwayInputBox_state",
    "BookOfMind_ttsPreviewEnabled",
    "BookOfMind_ttsVoice",
}

export enum ESharedFunctionMultiple {
    "ChevronPanel_isOpen",
    "QuickSaveIcon_saveState",
    "StackDream_isLoading",
    "StackGoal_isLoading",
}
